<!-- ── CHIP MODE ────────────────────────────────────────────────────────────── -->
<ng-container *ngIf="mode === 'chip'">
  <div class="ad-chip-list">
    <div *ngFor="let a of displayed" class="ad-chip-wrap">
      <div class="ad-chip">
        <span class="ad-chip-name">{{ assetName(a) }}</span>
        <span *ngIf="a.criticality" class="ad-chip-crit" [ngClass]="critClass(a.criticality)">{{ a.criticality }}</span>
      </div>
      <!-- Hover card -->
      <div class="ad-tooltip">
        <div class="ad-tooltip-name">{{ assetName(a) }}</div>
        <div class="ad-tooltip-id" *ngIf="a.assetId">{{ a.assetId }}</div>
        <div class="ad-tooltip-grid">
          <ng-container *ngIf="a.category || a.assetCategory">
            <span class="ad-tl">Category</span><span class="ad-tv">{{ a.category || a.assetCategory }}</span>
          </ng-container>
          <ng-container *ngIf="a.subCategory">
            <span class="ad-tl">Sub-category</span><span class="ad-tv">{{ a.subCategory }}</span>
          </ng-container>
          <ng-container *ngIf="a.criticality">
            <span class="ad-tl">Criticality</span>
            <span class="ad-tv"><span class="ad-badge" [ngClass]="critClass(a.criticality)">{{ a.criticality }}</span></span>
          </ng-container>
          <ng-container *ngIf="a.exposure">
            <span class="ad-tl">Exposure</span>
            <span class="ad-tv"><span class="ad-badge" [ngClass]="exposureClass(a.exposure)">{{ a.exposure }}</span></span>
          </ng-container>
          <ng-container *ngIf="a.owner">
            <span class="ad-tl">Owner</span><span class="ad-tv">{{ a.owner }}</span>
          </ng-container>
          <ng-container *ngIf="a.assignedTo">
            <span class="ad-tl">Assigned to</span><span class="ad-tv">{{ resolveString(a.assignedTo) }}</span>
          </ng-container>
          <ng-container *ngIf="a.source">
            <span class="ad-tl">Source</span><span class="ad-tv">{{ a.source }}</span>
          </ng-container>
          <ng-container *ngIf="a.location">
            <span class="ad-tl">Location</span><span class="ad-tv">{{ a.location }}</span>
          </ng-container>
          <ng-container *ngIf="a.riskScore != null">
            <span class="ad-tl">Risk score</span><span class="ad-tv">{{ a.riskScore }}</span>
          </ng-container>
          <ng-container *ngIf="(a.tags ?? []).length">
            <span class="ad-tl">Tags</span><span class="ad-tv">{{ tagsLabel(a) }}</span>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="overflow > 0" class="ad-chip ad-chip--more">+{{ overflow }} more</div>
  </div>
</ng-container>

<!-- ── TABLE MODE ───────────────────────────────────────────────────────────── -->
<ng-container *ngIf="mode === 'table'">
  <div class="ad-table-wrap">
    <table class="ad-table">
      <thead>
        <tr>
          <th>Asset</th>
          <th>Category</th>
          <th>Criticality</th>
          <th>Exposure</th>
          <th>Owner</th>
          <th>Source</th>
          <th>Risk score</th>
          <th>Assigned to</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of displayed">
          <td class="ad-td-name">
            <div class="ad-asset-label">{{ assetName(a) }}</div>
            <div class="ad-asset-sub" *ngIf="a.assetId">{{ a.assetId }}</div>
          </td>
          <td class="ad-td-muted">
            {{ assetCategory(a) }}
            <span *ngIf="a.subCategory" class="ad-sub-cat"> / {{ a.subCategory }}</span>
          </td>
          <td>
            <span *ngIf="a.criticality" class="ad-badge" [ngClass]="critClass(a.criticality)">{{ a.criticality }}</span>
            <span *ngIf="!a.criticality">—</span>
          </td>
          <td>
            <span *ngIf="a.exposure" class="ad-badge" [ngClass]="exposureClass(a.exposure)">{{ a.exposure }}</span>
            <span *ngIf="!a.exposure">—</span>
          </td>
          <td class="ad-td-muted">{{ a.owner || '—' }}</td>
          <td class="ad-td-muted">{{ a.source || '—' }}</td>
          <td class="ad-td-num">{{ a.riskScore ?? '—' }}</td>
          <td class="ad-td-muted">{{ resolveString(a.assignedTo) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ad-view-all" *ngIf="overflow > 0">
    Showing {{ displayed.length }} of {{ totalCount }}
    <span class="ad-view-all-link">View all {{ totalCount }} assets &rsaquo;</span>
  </div>
</ng-container>
